import Dictionary from '@inqool/uas-web-core/es/components/app/Dictionary';
import { breadcrumbs } from '@inqool/uas-web-core/es/utils';
import { compose, withProps, onlyUpdateForKeys, setDisplayName } from 'recompose';
import { withRouter } from 'react-router-dom';

import { withClassname } from '@components/hoc/withClassname';
import * as React from 'react';
import { MyItemsForm } from '@modules/myItems/myItemsForm';
import { withAdditionalProps } from '@components/hoc/withAdditionalProps';
import { withColumns } from '@components/hoc/withColumns';
import { Agenda } from '@modules/columnSettings/_columnSettingsEnums';
import { ColumnManager } from '@modules/columnSettings/ColumnManager';

export const myItemsUrl = '/metropolis/api/owa/employee/items';
export const myItemsLabel = 'Moje předměty';
export const myItemsPath = '/warehouses/my-items';
export const myItemsGridName = 'MyItemsGrid';

export const MyItemsGrid = compose(
  withRouter,
  setDisplayName(myItemsGridName),
  onlyUpdateForKeys(['url', 'location']),
  breadcrumbs([{ label: myItemsLabel }]),
  withColumns(Agenda.MY_ITEMS),
  withProps(({ columns }) => ({
    name: myItemsGridName,
    url: myItemsUrl,
    Form: MyItemsForm,
    dialog: false,
    gridProps: {
      columns,
      filterRow: true,
      showCheckboxes: true,
      deleting: false,
      filtering: true,
      locale: 'cz',
      adding: false,
      pageSize: 50,
      version: 2,
      ActionBar: () => <ColumnManager agenda={Agenda.MY_ITEMS} />
    }
  })),
  withAdditionalProps,
  withClassname({ className: 'mp-grid' })
)(Dictionary);



// WEBPACK FOOTER //
// ./src/modules/myItems/myItemsGrid.tsx